export default (build) =>
  build.query({
    query: ({ search = "", limit = 10 }) => {
      const params = new URLSearchParams({
        limit: limit.toString(),
      });

      if (search) params.append("search", search);

      return {
        url: `/superadmin/users/search?${params.toString()}`,
        method: "GET",
      };
    },
    transformResponse: (response) => ({
      users: response.users || [],
      totalCount: response.totalCount || 0,
    }),
  });
